export const KpiActionBarEN = {
    "kpiActionBar": {
        "tab": {
            "detail": "Detail"
        },
        "item": {
            "delete": "Delete",
            "auditing": "History",
            "historyAction": "Activity History",
            "update": "Update",
            "confirm": "Confirm",
            "notConfirm": "Undo Confirmation",
            "back": "Go Back",
            "result": "Result",
            "evaluate": "Evaluate",
            "evaluateModal": "KPI Evaluation Period",
            "time": "Time"
        },
        "message": {
            "deleteAsk": "Are you sure you want to delete?",
            "deleteTemplateAsk": "Are you sure you want to delete the KPI evaluation template?",
            "deletePeriodAsk": "Are you sure you want to delete the KPI evaluation period?",
            "confirmAsk": "Are you sure you want to confirm the KPI evaluation period?",
            "notConfirmAsk": "Are you sure you want to undo the confirmation of the KPI evaluation period?"
        }
    }
}